import { Typography } from "@suraasa/placebo-ui"
import { SuraasaPlusSubscriptionStatus } from "api/resources/suraasaPlus/types"
import PageContainer from "components/PageContainer"
import addDays from "date-fns/addDays"
import { formatDate } from "utils/helpers"

import UpdatePaymentDetailsButton from "../components/UpdatePaymentDetailsButton"
import { useSuraasaPlusContext } from "../context"
import WarningTriangle from "./_assets/warning-triangle.svg"

const PaymentFailedBanner = () => {
  const { subscriptionDetails } = useSuraasaPlusContext()

  const validThroughDate = subscriptionDetails?.subscription.validThrough

  if (
    subscriptionDetails?.subscription.status ===
    SuraasaPlusSubscriptionStatus.paymentOverdue
  )
    return (
      <div className="bg-warning-50 py-2">
        <PageContainer>
          <div className="flex flex-row gap-1.5">
            <img
              src={WarningTriangle}
              alt="payment-failed"
              className="size-3"
            />
            <div className="flex flex-col justify-between sm:w-full sm:flex-row">
              <div className="flex flex-col">
                <Typography
                  variant="title4"
                  className="mb-0.5 text-onSurface-900"
                >
                  We couldn&apos;t process your payment for Suraasa Plus.
                </Typography>
                {validThroughDate && (
                  <Typography
                    variant="smallBody"
                    className="text-onSurface-600"
                  >
                    Please update your billing details to avoid losing access.
                    We’ll retry until{" "}
                    {formatDate(
                      addDays(
                        new Date(validThroughDate),
                        subscriptionDetails?.subscription.gracePeriod || 0
                      )
                        .toISOString()
                        .split("T")[0],
                      "dd MMMM yyyy"
                    )}
                    .
                  </Typography>
                )}
              </div>
              <UpdatePaymentDetailsButton className="mt-1.5 w-fit shrink-0 bg-warning-900 p-1 text-white sm:mt-0" />
            </div>
          </div>
        </PageContainer>
      </div>
    )
}

export default PaymentFailedBanner
